<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Base de Gestiones</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <!-- <v-row dense>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col >
                        <v-autocomplete :items="listaTiposGestion" v-model="filtro.tipoGestionId"
                                item-text="descripcion" item-value="id" label="Tipo de Gestión"></v-autocomplete>
                    </v-col>

                    <v-col >
                        <!-- <v-autocomplete :items="listaTareasFiltered" v-model="filtro.tareaId" placeholder="Dejar en blanco para Todas" clearable
                                item-text="descripcion" item-value="id" label="Tarea"></v-autocomplete> -->
                        
                        <v-flex>
                            <v-select
                                label='Tarea'
                                v-model="filtro.tareasIds"
                                :items="listaTareasFiltered"
                                item-text="descripcion"
                                item-value="id"
                                multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item
                                    ripple
                                    @click="toggleTareas(listaTareasFiltered)"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="filtro.tareasIds.length > 0 ? 'indigo darken-4' : ''">{{ iconTareas }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Marcar todas</v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <!-- ARRIBA esto es para agregar la opción de select all -->
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index <= 2">
                                    <span>{{ item.descripcion }}</span>
                                    </v-chip>
                                    <span
                                    v-if="index === 3"
                                    class="grey--text caption"
                                    >(+{{ filtro.tareasIds.length - 3 }} más)</span>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-col>

                    <v-col >
                        <!-- <v-autocomplete :items="listaRespuestas" v-model="filtro.respuestaId" placeholder="Dejar en blanco para Todas" clearable
                                item-text="descripcion" item-value="id" label="Respuesta" loading="loadingRespuestas"></v-autocomplete> -->
                        <v-flex>
                            <v-select
                                label='Respuesta'
                                v-model="filtro.respuestasIds"
                                :items="listaRespuestas"
                                item-text="descripcion"
                                item-value="id"
                                multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item
                                    ripple
                                    @click="toggleRespuestas(listaRespuestas)"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="filtro.respuestasIds.length > 0 ? 'indigo darken-4' : ''">{{ iconRespuestas }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Marcar todas</v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <!-- ARRIBA esto es para agregar la opción de select all -->
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index <= 2">
                                    <span>{{ item.descripcion }}</span>
                                    </v-chip>
                                    <span
                                    v-if="index === 3"
                                    class="grey--text caption"
                                    >(+{{ filtro.respuestasIds.length - 3 }} más)</span>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-col>
                </v-row>

               <v-row dense>
                    <v-col cols="2" >
                       <v-text-field v-model="filtro.fechaDesde" label="Fecha Ejecución Desde" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="2" >
                       <v-text-field v-model="filtro.fechaHasta" label="Fecha Ejecución Desde" type="date" ></v-text-field>
                    </v-col>
                    <v-col cols="2" >
                       <v-text-field v-model="filtro.documento" label="Documento" type="number" ></v-text-field>
                    </v-col>
                    <v-col cols="2" >
                        <v-checkbox v-model="filtro.incluirCrm" label="Incluir CRM" dense></v-checkbox>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col  >
                       <v-autocomplete :items="listaGestores" v-model="filtro.ejecutadaPor"
                                item-text="nombre" item-value="login" label="Realizada Por"></v-autocomplete>
                    </v-col>
                    <v-col  >
                       <v-autocomplete :items="listaGestores" v-model="filtro.asignadasA"
                                item-text="nombre" item-value="login" label="Asignadas A"></v-autocomplete>
                    </v-col>
                </v-row>
            
            
                <span class="title" >Opciones</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="2" lg="1">
                        <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
                    </v-col>                       
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesar">
                    Descargar&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            loadingRespuestas: false,
            filtro: {empresaId: 1, tipoGestionId: 0, documento: 0, incluirCrm: false,
                    fechaDesde: null, fechaHasta: null, ejecutadaPor: 0, asignadasA: 0, separador: ';',
                    tareasIds: [], respuestasIds: []},
            listEmpresas: [],
            listaRespuestas:[],
            listaTiposGestion:[],
            listaTareas:[],
            listaGestores: []
        }
    },
    async created() {
      this.loadEmpresas();
      
      this.loadTiposGestion();
      this.loadTareas();

      this.loadGestores();

      this.filtro.fechaDesde = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
    
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
        listaTareasFiltered:function(){
            if(!this.listaTareas) return [];

            const listaTareasFiltrada = this.listaTareas.filter((e) => e.tipoGestionId == this.filtro.tipoGestionId);
      
            return listaTareasFiltrada;
        },
        todasLasTareasMarcadas () {
        return this.filtro.tareasIds.length === this.listaTareas.length
        },
        algunasTareasMarcadas () {
        return this.filtro.tareasIds.length > 0 && !this.todasLasTareasMarcadas
        },
        iconTareas () {
        if (this.todasLasTareasMarcadas) return 'mdi-close-box'
        if (this.algunasTareasMarcadas) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
        },
        todasLasRespuestassMarcadas () {
        return this.filtro.respuestasIds.length === this.listaRespuestas.length
        },
        algunasRespuestasMarcadas () {
        return this.filtro.respuestasIds.length > 0 && !this.todasLasRespuestassMarcadas
        },
        iconRespuestas () {
        if (this.todasLasRespuestassMarcadas) return 'mdi-close-box'
        if (this.algunasRespuestasMarcadas) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
        },
    },
    watch:{
        'filtro.tareasIds': function(){
            this.loadRespuestas();
        },
    },
    methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadTiposGestion(){
      this.loading = true;
      try{
        var result = await http.get('tiposgestion');

        this.listaTiposGestion = result.list;
        this.listaTiposGestion.unshift({id:0, descripcion: '(Todas)'});

      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTareas(){
      this.loading = true;
      try{
        var result = await http.get('gestion/listtareasgestion');

        this.listaTareas = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadRespuestas(){
      if(!this.filtro || !this.filtro.tareasIds) return;
      
      console.log(this.filtro.tareasIds)

      this.loadingRespuestas = true;
      try{
        var result = await http.get('gestion/listrespuestasportareasgestion?tareasIds=' + this.filtro.tareasIds.toString());

        this.listaRespuestas = result.list;

        if(this.listaRespuestas.length > 0)
            this.filtro.respuestaId = this.listaRespuestas[0].id; // selecciona la 1ra
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loadingRespuestas = false;
    },
    async loadGestores(){
      this.loading = true;
      try{
        var result = await http.get('usuarios/listByRol?rolId=4');//traigo los usuarios con rol gestor

        this.listaGestores = result.list;
        this.listaGestores.unshift({id:"00000000-0000-0000-0000-000000000000", nombre: '(Todos)', login:'0'});

        this.filtro.ejecutadaPor = this.listaGestores[0].login;
        this.filtro.asignadasA = this.listaGestores[0].login;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    toggleTareas(list){

        this.$nextTick(() => {
          if (this.todasLasTareasMarcadas) {
            this.filtro.tareasIds = []
          } else {
            this.filtro.tareasIds = list.map(function(p) {return p.id;});
          }
        })
    },
    toggleRespuestas(list){

        this.$nextTick(() => {
          if (this.todasLasRespuestassMarcadas) {
            this.filtro.respuestasIds = []
          } else {
            this.filtro.respuestasIds = list.map(function(p) {return p.id;});
          }
        })
    },
    async procesar(){
         // validaciones
         
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return;
        }
        var self = this;

        var params = {
            empresaId: self.filtro.empresaId,
            tipoGestionId: self.filtro.tipoGestionId,
            tareasIds: self.filtro.tareasIds.toString(),
            respuestasIds: self.filtro.respuestasIds.toString(),
            asignadasA: self.filtro.asignadasA,
            ejecutadaPor: self.filtro.ejecutadaPor,
            fechaDesde: self.filtro.fechaDesde,
            fechaHasta: self.filtro.fechaHasta,
            incluirAccionesCredito: self.filtro.incluirAccionesCredito,
            separador: self.filtro.separador,
            documento: self.filtro.documento,
            incluirCrm: self.filtro.incluirCrm
        }

        try {
            self.loading = true;

            await http.post('filegeneration/basegestiones', JSON.stringify( {parametros: params} ) )
                .then(resp => {
                    console.log(resp);

                    if(resp.error ){
                        self.alertError(resp.error);
                    }
                    else{
                        self.alertSuccess('Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...');
                        
                        self.loading = true;
                        self.downloadFile(resp, 'BaseGestiones.csv');
                        self.loading = false;
                    }

                })
                .catch((e) => {
                    self.alertError(e)
                });
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },

},
  
}
</script>